<section>
  <div class="header-inner-wrapper">
    <div>
      <cigna-header-logo
        [path]="isNavigationDisabled ? '' : logoLink"
        [internal]="isLogoLinkInternal"
      ></cigna-header-logo>
    </div>
    <div class="header-util-container cg-hide-for-print">
      <cigna-resources-search-form
        *ngIf="!isNavigationDisabled || isResourceResults"
        [secure]="isAuthenticated"
        [resourcesPage]="isResourceLibraryApp"
      ></cigna-resources-search-form>
      <button
        *ngIf="
          isAuthenticated && !isNavigationDisabled && !isResourceLibraryApp
        "
        (click)="logOut.emit({ variation: 'logout', linkName: 'Logout' })"
        data-test="button-logout"
        cignaButton="link"
        class="header-link"
      >
        Logout
      </button>

      <cigna-header-user-util
        *ngIf="isAuthenticated && !isNavigationDisabled"
        [firstName]="firstName"
        [lastName]="lastName"
        [userid]="userid"
        [profileLinks]="profileLinks"
        [impersonator]="isImpersonator"
        [hasMessageCenterFunction]="hasMessageCenterFunction"
        [isOhpUser]="isOhpUser"
      ></cigna-header-user-util>
    </div>
  </div>
</section>
